<template>
  <face-rule
    @agree="handleAgree"
    :show-cancel="showCancel !== 'notice'"
  ></face-rule>
</template>

<script>
import mixin from '@/mixin'
import { mcToast } from '@/utils/mcSdkUtils'
import { faceRule } from '@/components'
export default {
  name: 'PageFaceInputRule',
  mixins: [mixin],
  components: { faceRule },
  data() {
    return {
      showCancel: this.$route.query.$sourceOrigin || ''
    }
  },
  computed: {},
  created() {},
  methods: {
    handleAgree() {
      this.getApi('faceGuardianAgree', {}, true).then(res => {
        if (res === true) {
          mcToast({ msg: '授权成功' })
          setTimeout(() => {
            this.mixinRouter('/faceInput/guardian')
          }, 3000)
        }
      })
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
